
namespace GeniuzPOS.Inventory {

    @Serenity.Decorators.registerClass()
    export class IcStockReceiveDtDialog extends Serenity.Extensions.GridEditorDialog<IcStockReceiveDtRow> {
        protected getFormKey() { return IcStockReceiveDtForm.formKey; }
        // protected getIdProperty() { return IcStockReceiveDtRow.idProperty; }
        protected getLocalTextPrefix() { return IcStockReceiveDtRow.localTextPrefix; }
        protected getNameProperty() { return IcStockReceiveDtRow.nameProperty; }
        protected getService() { return IcStockReceiveDtService.baseUrl; }
        // protected getDeletePermission() { return IcStockReceiveDtRow.deletePermission; }
        // protected getInsertPermission() { return IcStockReceiveDtRow.insertPermission; }
        // protected getUpdatePermission() { return IcStockReceiveDtRow.updatePermission; }

        protected form = new IcStockReceiveDtForm(this.idPrefix);

        public qnNo: number;
        public purprice: number;
        public StkUnitT: string;
        public purratio: number;
        public purpz: number;
        public lsprun: number;

        constructor() {
            super();

            this.form = new IcStockReceiveDtForm(this.idPrefix);


            this.form.SkuCode.change(e => {
                var skucode = Q.toId(this.form.SkuCode.value);
                var sku = this.form.SkuCode.value
                var skuen = this.entity.SkuCode
                this.form.UnitChange.set_value(null);

                console.log(sku)
                console.log(skucode)
                console.log(skuen)

                if (skucode != null) {
                    // Q.first(Product.CsSkuRow.getLookup().items,x =>x.StkUnit == skucode).StkUnit;
                    //this.StkUnitT = Product.CsSkuRow.getLookup().itemById[skucode].StkUnit || Product.CsSkuRow.getLookup().itemById[sku].StkUnit || '';
                    // this.form.PurUnit.value = Product.CsSkuRow.getLookup().itemById[skucode||sku].PurUnit||'';
                    // this.form.PurUnitRatio.value = Product.CsSkuRow.getLookup().itemById[skucode].PurUnitRatio;
                    // this.form.LastPurPrice.value = Product.CsSkuRow.getLookup().itemById[skucode].LastPurPrice;

                    // this.form.ItemRemark.value = Product.CsSkuRow.getLookup().itemById[skucode].SkuDesc + " X" + this.form.PurUnitRatio.value.toString() || 1 + " " + this.StkUnitT;
                    this.form.UnitChange.set_value("1");

                }
            });
            // this.form.UnitChange.element.parent();
            this.form.UnitChange.change(e => {
                
                var sku :string= this.form.SkuCode.value
                var skucode: string = Q.toId(this.form.SkuCode.value);
                var stku = this.StkUnit;
                var puru = this.PurUnit;
                console.log(skucode)    
                console.log(sku)    
                console.log(stku)                
            
            
                if (skucode != null) {
                    this.StkUnitT = Product.CsSkuRow.getLookup().itemById[sku].StkUnit;
                    this.purratio = Product.CsSkuRow.getLookup().itemById[sku].PurUnitRatio;
                    this.purpz = Product.CsSkuRow.getLookup().itemById[sku].PurUnitPrice;
                    this.lsprun =  Product.CsSkuRow.getLookup().itemById[sku].LastPurPrice;

                    if (!puru) {

                        this.form.PurUnit.value = Product.CsSkuRow.getLookup().itemById[sku].PurUnit;
                        this.form.PurUnitRatio.value = this.purratio
                        this.form.PurUnitPrice.value = this.purpz
                        this.form.LastPurPrice.value = this.lsprun
                        this.form.ItemRemark.value = Product.CsSkuRow.getLookup().itemById[sku].SkuDesc + " (X" + this.form.PurUnitRatio.value.toString() + " " + this.StkUnitT + ")" + this.form.PurUnit.value;

                        this.form.Qty.value = 1;
                        this.form.CostValue.value = (this.form.PurUnitPrice.value || 0) * (this.form.Qty.value || 0);

                    }
                    else if (!stku) {
                        // this.StkUnitT = Product.CsSkuRow.getLookup().itemById[sku].StkUnit;
                        this.form.PurUnit.value = Product.CsSkuRow.getLookup().itemById[sku].StkUnit;
                        this.form.PurUnitRatio.value = 1;
                        this.form.ItemRemark.value = Product.CsSkuRow.getLookup().itemById[sku].SkuDesc + " X" + this.form.PurUnitRatio.value.toString() + " " + this.StkUnitT;
                        this.form.Qty.value = 1;

                        if (this.purratio == 0) {
                            this.form.PurUnitPrice.set_value(0);
                            this.form.LastPurPrice.set_value(0);
                        } else {
                            this.form.PurUnitPrice.value = this.purpz / (this.purratio || 1);
                            this.form.LastPurPrice.value = this.lsprun / (this.purratio || 1);
                        }

                        //this.form.UnitChange.set_value("0");

                        this.form.CostValue.value = (this.form.PurUnitPrice.value || 0) * (this.form.Qty.value || 0);
                        // this.form.CostValue.value = 0;

                    }


                }
            });



            this.form.CostValue.change(e => {
                var skucode = Q.toId(this.form.SkuCode.value);
                var q = Q.toId(this.form.Qty.value)
                if (skucode != null) {

                    if (q = 0) {
                        this.form.PurUnitPrice.value = (this.form.CostValue.value || 0) / 1;
                    } else {
                        this.form.PurUnitPrice.value = (this.form.CostValue.value || 0) / (this.form.Qty.value || 1);
                    }

                }
            });


            this.form.Qty.change(e => {
                var skucode = Q.toId(this.form.SkuCode.value);
                if (skucode != null) {

                    if (this.form.Qty.value == null || this.form.Qty.value == 0)
                {
                    throw new console.error("Qty ERROR");                    
                }
                    this.form.CostValue.value = (this.form.PurUnitPrice.value || 0) * (this.form.Qty.value || 0);


                }
            });
            this.form.PurUnitPrice.change(e => {
                var skucode = Q.toId(this.form.SkuCode.value);
                if (skucode != null) {


                    this.form.CostValue.value = (this.form.PurUnitPrice.value || 0) * (this.form.Qty.value || 0);


                }
            });



        }
        private get StkUnit() {
            return this.form.UnitChange.value != "0";
        }
        private get PurUnit() {
            return this.form.UnitChange.value != "1";
        }
        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();
            
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);

                let newBtn: Serenity.ToolButton =
                {
                    title: "บันทึกและสร้างรายการถัดไป",
                    hint: "Save and new",
                    separator: false,
                    cssClass: "button-saveandnew",
                    icon: "fa fa-save",
                    hotkey: 'alt+s',
                    onClick: (e) => {

                        if(this.form.Qty.value == null){
                            this.form.Qty.value = 0
                        }
                        e.preventDefault();
                        this.saveAndNew();
                    }
                };
                buttons.push(newBtn)
           

            buttons.push(
                {
                    title: Q.text("Close"),	// *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    hint: 'esc',
                    hotkey: 'esc',
                    onClick: () => {
                        this.dialogClose();
                        // *** do something on click if you want **

                    },
                }
            );

            return buttons;
        }
        private saveAndNew() {
            let e = this.entity; let f = this.form;
            this.save((response) => {
                let ent: IcStockReceiveDtRow = { SysDocNo: e.SysDocNo };
                this.loadEntity(ent);
            });
        }
        protected beforeLoadEntity() {
            let self = this;


            self.toolbar.findButton('save-and-close-button').text('บันทึกรายการ');
            self.toolbar.findButton('delete-button').text('ลบรายการ');

            let nbrRetry = 0;
            (function changeTitle() {
                if (nbrRetry >= 10) {
                    return;
                }

                setTimeout(() => {
                    if ((self as any).isMarkedAsPanel === true) {
                        if (self.element.find(".ui-dialog-title").length == 1) {
                            self.element.find(".ui-dialog-title").html("");
                            self.element.find(".ui-dialog-titlebar-text").html("");
                            self.element.find(".ui-dialog-titlebar-close").html("");//panel-titlebar
                        }
                        else {
                            changeTitle();
                        }
                    }
                    else {
                        if (self.element.parent().find(".ui-dialog-title").length == 1) {
                            self.element.parent().find(".ui-dialog-title").html("");
                            self.element.parent().find(".ui-dialog-titlebar-text").html("");
                            self.element.parent().find(".ui-dialog-titlebar-close").html("");
                        }
                        else {
                            changeTitle();
                        }
                    }
                }, 10);
            })();

        }
        protected afterLoadEntity() {
            super.afterLoadEntity();

            let app = Q.tryFirst(Lookups.SysParaRow.getLookup().items, x => x.Id == 16 && x.SysFg > 0)
            console.log(app)
            if (app != null) {
                this.form.ExpDate.getGridField().toggle(true);
            } else {
                this.form.ExpDate.getGridField().toggle(false);
            }

          
        }
        protected getCssClass() {
            super.getCssClass();
            return "fixRight";

        }

    }
}